export default __webpack_public_path__ + "static/media/two.0c022fb2.jpg";